import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "blog-panel" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "background-shadow" }, null, -1)


const __default__ = { name: 'BlogPanel' };

import {reactive, ref, onBeforeMount, onMounted} from 'vue';



export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

onMounted(() => {
  // console.log('3.-组件挂载到页面之后执行-------onMounted');
});
expose({
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})